const ProductionStatus = [
  {
    id: 0,
    name: "In Produzione",
    key: "PRODUCING",
  },
  {
    id: 1,
    name: "Prodotto",
    key: "PRODUCED",
  },
  {
    id: 2,
    name: "Non Prodotto",
    key: "NOT_PRODUCED",
  }
];

export { ProductionStatus };